import Vue from 'vue';
import Vuex from 'vuex';
import modules from './modules';
import VuexPersistence from 'vuex-persist';
import localforage from 'localforage';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

// Quando é chamada a mutation para restaurar os dados, envio um evento para informar os componentes da aplicação
const vuexPersistEmitter = () => {
  return (store) => {
    store.subscribe((mutation) => {
      if (mutation.type === 'RESTORE_MUTATION') {
        store._vm.$root.$emit('storageReady');
      }
    });
  };
};

// Definição da gravação de dados da aplicação
const vuexLocal = new VuexPersistence({
  strictMode: true,
  storage: localforage,
  modules: [
    'attendance',
    'agents',
    'auth',
    'channel',
    'contact',
    'pause',
    'jobs',
    'qualify',
    'system',
    'presetMessages',
    'tag',
    'whatsapp',
    'whatsappCampaigns',
    'chatVisor',
    'observation',
    'notifications',
    'attendanceGroups',
    'broadcast',
    'inlineEditing',
    '_connection',
    '_employer',
    '_campaigns',
    'sidebars',
    'templatesMailing',
    // 'email',
  ],
});

const mutationTree = { RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION };

export default new Vuex.Store({
  mutations: mutationTree,
  modules,
  strict: debug,
  asyncStorage: true,
  plugins: [vuexLocal.plugin, vuexPersistEmitter()],
});
